import React, { FunctionComponent, useRef, useState } from 'react';
import styles from './ForgotPassword.module.scss';
import TextInput from 'app/components/Form/Inputs/TextInput';
import { _t } from 'app/utils/i18n';
import { LoginPattern } from 'app/assets/images/icons';
import { useMutation } from 'react-query';
import { forgotPassword } from 'auth/Requests';
import { useCustomForm } from 'app/hooks/useCustomForm';
import ReCAPTCHA from 'react-google-recaptcha';
import { emailValidationSchema } from '../validationSchema';
import {
  constants,
  getFromLocalStorage,
  setInLocalStorage,
} from 'app/utils/localStorage';
import { useHistory } from 'react-router-dom';
import { path } from 'app/utils/path';
import Loader from 'app/components/Loader';
import { checkIsMockGoogleRecaptcha } from 'app/utils/check-mock-google-recaptcha';
const currentLanguage = getFromLocalStorage(constants.language);

const ForgetPassword: FunctionComponent = () => {
  const history = useHistory();
  const [isLoading, setIsloading] = useState(false);
  const [emailSent, setEmailSent] = useState('');
  const forgotPasswordAsync = useMutation(forgotPassword);

  const onSubmit = async (values: any) => {
    setIsloading(true);
    let token = '';
    if (checkIsMockGoogleRecaptcha()) {
      token = await reRef.current.executeAsync();
      reRef.current.reset();
    }
    await forgotPasswordAsync
      .mutateAsync({ email: values?.email, token })
      .then((res: any) => {
        if (res?.code === 200) {
          setEmailSent(res?.message);
        }
      });
    setIsloading(false);
  };

  const {
    handleSubmit,
    changeHandler,
    formState: { errors },
  } = useCustomForm(emailValidationSchema, {});
  const reRef = useRef<ReCAPTCHA>();
  const setLang = (lng: string) => {
    setInLocalStorage(constants.language, lng);
    location.reload();
  };

  return (
    <>
      {checkIsMockGoogleRecaptcha() && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as any}
          size="invisible"
          ref={reRef as any}
        />
      )}
      <div className={styles.SignIn}>
        <LoginPattern />
        <div className={styles.alert}>
          {_t('login:Request_Sent_Successfully')}
        </div>
        <div className={styles.loginBox}>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {!!emailSent ? (
                <form
                  className={`${styles.form} ${styles.emailSent}`}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <p>{emailSent}</p>
                  <div className={styles.button_Box}>
                    <button onClick={() => history.replace(path.auth.SIGN_IN)}>
                      {_t('return_home')}
                    </button>
                  </div>
                </form>
              ) : (
                <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                  <div className={styles.top}>
                    <p>{_t('login:Forgot_password')}</p>
                    {/* <span>{_t('login:Please_Enter')}</span> */}
                  </div>
                  <div className={styles.field}>
                    <div className={styles.field_top}>
                      <span> {_t('login:Wrong_Email')}</span>
                    </div>
                    <TextInput
                      label={_t('login:email')}
                      type="text"
                      name="email"
                      error={errors?.email?.message}
                      onChange={(e) => changeHandler('email', e)}
                    />
                  </div>
                  <div className={styles.button_Box}>
                    <button> {_t('login:Send')}</button>
                    {currentLanguage == 'en' ? (
                      <a
                        onClick={() => setLang('ar')}
                        style={{ cursor: 'pointer' }}
                      >
                        {_t('basic:ar')}
                      </a>
                    ) : (
                      <a
                        onClick={() => setLang('en')}
                        style={{ cursor: 'pointer' }}
                      >
                        {_t('basic:en')}
                      </a>
                    )}
                  </div>
                </form>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
